import { useEffect, useState } from "react";
import AddGreenFeeCalendar from "./addGreenFeeCalendar";
import { getGreenFeeCalendarAll, getGreenFeeMasterByCalenderID, postGreenFeeMaster } from "../api/teeTimeAPI";
import RightSideDetails from "../global/rightSideDetails";
import * as helper from '../global/helper';
import moment from "moment";
import { today as todayFromServer } from '../../assets/scripts/periodSelection';

const GreenFeeCalendar = (props) => {
    const [currentCalendarID, setCurrentCalendarID] = useState(null);
    const rows = [
    { no: 1,  CategoryID: 1, SubCategoryID: 1,Hole: 18, UserType: 'Member', Type: 'Weekday' },
    { no: 2,  CategoryID: 1, SubCategoryID: 1, Hole: 18, UserType: 'Member', Type: 'Weekends' },
    { no: 3,  CategoryID: 1, SubCategoryID: 1, Hole: 9, UserType: 'Member', Type: 'Weekday' },
    { no: 4,  CategoryID: 1, SubCategoryID: 1, Hole: 9, UserType: 'Member', Type: 'Weekends' },
    // { no: 5,  CategoryID: 1, SubCategoryID: 2, Hole: 18, UserType: 'Residential Member', Type: 'Weekday' },
    // { no: 6,  CategoryID: 1, SubCategoryID: 2, Hole: 18, UserType: 'Residential Member', Type: 'Weekends' },
    // { no: 7,  CategoryID: 1, SubCategoryID: 2, Hole: 9, UserType: 'Residential Member', Type: 'Weekday' },
    // { no: 8,  CategoryID: 1, SubCategoryID: 2, Hole: 9, UserType: 'Residential Member', Type: 'Weekends' },
    { no: 5,  CategoryID: 1, SubCategoryID: 3, Hole: 18, UserType: 'Junior Member', Type: 'Weekday' },
    { no: 6, CategoryID: 1, SubCategoryID: 3, Hole: 18, UserType: 'Junior Member', Type: 'Weekends' },
    { no: 7, CategoryID: 1, SubCategoryID: 3, Hole: 9, UserType: 'Junior Member', Type: 'Weekday' },
    { no: 8, CategoryID: 1, SubCategoryID: 3, Hole: 9, UserType: 'Junior Member', Type: 'Weekends' },
    { no: 9, CategoryID: 2, SubCategoryID: 4, Hole: 18, UserType: 'Walk-in Guest', Type: 'Weekday' },
    { no: 10, CategoryID: 2, SubCategoryID: 4, Hole: 18, UserType: 'Walk-in Guest', Type: 'Weekends' },
    { no: 11, CategoryID: 2, SubCategoryID: 4, Hole: 9, UserType: 'Walk-in Guest', Type: 'Weekday' },
    { no: 12, CategoryID: 2, SubCategoryID: 4, Hole: 9, UserType: 'Walk-in Guest', Type: 'Weekends' },
    { no: 13, CategoryID: 2, SubCategoryID: 5, Hole: 18, UserType: 'Members Guest', Type: 'Weekday' },
    { no: 14, CategoryID: 2, SubCategoryID: 5, Hole: 18, UserType: 'Members Guest', Type: 'Weekends' },
    { no: 15, CategoryID: 2, SubCategoryID: 5, Hole: 9, UserType: 'Members Guest', Type: 'Weekday' },
    { no: 16, CategoryID: 2, SubCategoryID: 5, Hole: 9, UserType: 'Members Guest', Type: 'Weekends' },
    { no: 17, CategoryID: 2, SubCategoryID: 6, Hole: 18, UserType: 'Hotel Guest', Type: 'Weekday' },
    { no: 18, CategoryID: 2, SubCategoryID: 6, Hole: 18, UserType: 'Hotel Guest', Type: 'Weekends' },
    { no: 19, CategoryID: 2, SubCategoryID: 6, Hole: 9, UserType: 'Hotel Guest', Type:'Weekday' },
    { no :20 , CategoryID :2 ,SubCategoryID :6 ,Hole :9 ,UserType :'Hotel Guest',Type :'Weekends'}
];

    const getInitialRateMaster = (calendarID = null) => {
        return rows.map(row => ({
            ID: row.ID,
            CalenderID: calendarID,
            CategoryID: row.CategoryID,
            SubCategoryID: row.SubCategoryID,
            UserType: row.UserType,
            Name: '',
            Hole: row.Hole,
            IsWeekend: row.Type == "Weekday" ? "N" : "Y",
            Type: row.Type,
            GreenFee: 0,
            Cart: 0,
            Caddy: 0,
            Tax: 0,
            Total: 0,
            Remark: ''
        }));
    };

    const [showModal,                             setShowModal]                                  = useState(false);
    const [isInit,                                setIsInit]                                     = useState(true);
    const [allMaster,                             setAllMaster]                                  = useState([]);
    const [greenFeeMaster,                        setGreenFeeMaster]                             = useState([]);
    const [rightSideDetails,                      setRightSideDetails]                           = useState(false);
    const [editingCalendar,                       setEditingCalendar]                            = useState(null);
    const [isRateEditable,                        setIsRateEditable]                             = useState(true);
    
    useEffect(() => {
        props.title("GreenFee Calendar", "green-fee-calendar");
        fetchGreenFeeCalendar();
    }, []);

    useEffect(() => {  
        // rightSideDetails ? Config.Core.OpenDrawer() : setGreenFeeMaster([]);
        if (rightSideDetails) {
            Config.Core.OpenDrawer();
        } else {
            setGreenFeeMaster(getInitialRateMaster());
            setCurrentCalendarID(null);
        }
    }, [rightSideDetails]);

    useEffect(() => {
        if (!isInit) {
            fillDataTable();
        }
    }, [allMaster]);

    const handleMasterClick = (e) => {
        e.preventDefault();
        setShowModal(true);
        setEditingCalendar(null);
    };

    const handleDismissModal = () => {
        setShowModal(false);
        setEditingCalendar(null);
    };

    const handleEditClick = (calendarData) => {
        setEditingCalendar(calendarData);       
        setShowModal(true);
    };  

    const fetchGreenFeeCalendar = async () => {
        try {
            const response = await getGreenFeeCalendarAll();
            isInit ? setIsInit(false) : $('#tblMaster').KTDatatable().destroy();
            setAllMaster(response.allGreenFeeCalendar);
        } catch (error) {
            swal.fire({ icon :'error', titleText : error.message });
        }
    };

    const fetchGreenFeeMasterByCalendarID = async (calendarID) => {
        try {
            setCurrentCalendarID(calendarID);
            const result = await getGreenFeeMasterByCalenderID(calendarID);
            if (result?.greenFeeMaster?.length > 0) {
                setGreenFeeMaster(result.greenFeeMaster);
            } else {
                setGreenFeeMaster(getInitialRateMaster(calendarID));
            }
            // setGreenFeeMaster(result?.greenFeeMaster);
        } catch (error) {
            swal.fire({ icon :'error', titleText : error.message });
        }
    };

    function fillDataTable() {
        const dataTable = $('#tblMaster').KTDatatable({
            data: {
                saveState: false,
                source   : allMaster,
                pageSize : 20
            },
            layout: {
                scroll: true,
                height: $(window).height() - 250,
                footer: false,
            },
            sortable   : true,
            pagination : true,
            search     : { input: $('#generalSearch') },
            columns    : [
                {  field: 'Name',  title: 'Name', width:250 },
                {
                    field: 'StartDate',
                    title: 'Start Date',
                    width: 120,
                    template: (row) => moment(row.StartDate).format('DD-MMM-YYYY'),  
                },
                {
                    field: 'EndDate',
                    title: 'End Date', width:120,
                    template: (row) => moment(row.EndDate).format('DD-MMM-YYYY'),                                    
                },                               
                {
                    field: '',
                    title: 'Action',
                    width: 90,
                    template: function (row) {
                        return showEditButton(row);
                    }
                },
            ]
        });

        dataTable.on('click', '.btn-invoice', function (e) {
            e.stopPropagation();
            const $row = $(this).closest('tr');
            const index = $row.index();
            const rowData = dataTable.dataSet[index];
            if (rowData) {
                const today = moment(todayFromServer)
                const isBetween = today.isSameOrAfter(moment(rowData.StartDate)) && today.isSameOrBefore(moment(rowData.EndDate)); // checking if calendar is active or not
                setIsRateEditable(!isBetween);
                setRightSideDetails(true);
                fetchGreenFeeMasterByCalendarID(rowData?.ID);
            }
        });

        // for edit button click
        dataTable.on('click', '.btn-edit', function (e) {
            e.stopPropagation();
            e.preventDefault();
            e.stopImmediatePropagation();
            const $row = $(this).closest('tr');
            const index = $row.index();
            const rowData = dataTable.dataSet[index];
            if (rowData) {
                handleEditClick(rowData);
            }
        });

        function showEditButton(row) {

            const formattedCurrentDate = moment(todayFromServer);
            
            var optString = '';

            const isEdit = formattedCurrentDate.isBetween(row.StartDate, row.EndDate);

            optString += '<center>'
            optString += `<button type="button" class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-invoice " ><i class="fa fa-file-alt"></i></button>`

            if (!isEdit) optString += `<button type="button"  class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-edit ml-4"><i class="flaticon2-edit"></i></button>`


            optString += '</center>'

            return optString;
        }       
    }

    const closeDrawer = () => {
        Config.Core.CloseDrawer();
        setTimeout(() => {
            setRightSideDetails(false);
            setIsRateEditable(true);
        }, 200);
    };

    const refetchCalendars = () => {
        fetchGreenFeeCalendar();
    };

    const updateGreenFeeMasterRate = (userType, hole, type, field, value) => {
        setGreenFeeMaster((prevDetails) => {
            return prevDetails.map(detail => {
                if (detail.UserType === userType && detail.Hole === hole && detail.Type === type) {
                    const updatedDetail = {
                        ...detail,
                        [field]: value
                    };

                    const greenFee = parseFloat(updatedDetail.GreenFee) || 0;
                    const cart     = parseFloat(updatedDetail.Cart) || 0;
                    const caddy    = parseFloat(updatedDetail.Caddy) || 0;

                    const rate = greenFee + cart + caddy;
                    
                    //Removing tax calculation as per new requirement, total will be sum of green fee, cart and caddy 
                    const tax = rate * 0.18;  
                    const total = rate + tax;
                 
                    updatedDetail.Tax = Math.round(tax);
                    updatedDetail.Total = Math.round(total);
                    
                    // updatedDetail.Total = Math.round(rate);
                    
                    return updatedDetail;
                }
                return detail;
            });
        });
    };

    const handleSave = async () => {
        const btn = $('#btnSave');
        helper.StartProcessing(btn);
        try {
            await postGreenFeeMaster(greenFeeMaster);
            if (greenFeeMaster[0].ID) {
                swal.fire({
                    toast: true,
                    icon: 'success',
                    titleText: 'Master updated successfully!',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3500,
                    onOpen: () => swal.hideLoading()
                });
            } else {
                swal.fire({
                    icon: 'success',
                    titleText: 'Master added successfully!',
                    showConfirmButton: false,
                    timer: 3500,
                    onOpen: () => swal.hideLoading()
                });
            }
            fetchGreenFeeMasterByCalendarID(currentCalendarID);
            helper.StopProcessing(btn);
        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon: 'error',
                titleText: 'Error!',
                text: err.message,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-brand',
            });
            return;
        }
    };

    return (
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content">
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet kt-portlet--mobile">
                        <div className="kt-portlet__head kt-portlet__head--lg padding-l0">
                            <div className="kt-portlet__head-label">
                                <div className="row align-items-center margin-l10">
                                    <div className="col-md-12 kt-margin-b-20-tablet-and-mobile margin-b0">
                                        <div className="kt-input-icon kt-input-icon--left">
                                            <input type="text" className="form-control clientSearch" placeholder="Search Master..." id="generalSearch" />
                                            <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="kt-portlet__head-toolbar">
                                <div className="kt-portlet__head-wrapper">
                                    <div className="kt-portlet__head-actions">
                                        <button onClick={handleMasterClick} type="button" className="btn btn-brand btn-icon-sm text-white d-inline"><i className="la la-plus"></i> New Master </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="kt-portlet__body kt-portlet__body--fit">
                            <div id="tblMaster" className="kt-datatable table-striped clickable"></div>
                            {rightSideDetails && <>                                
                                <RightSideDetails title="Green Fee Master" onCloseDrawer={() => closeDrawer()}>
                                    <div className="kt-portlet">
                                        <div className="kt-portlet__body padding-t30 padding-b0">
                                            <form className="kt-form" id="addMasterForm">
                                                <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                                    {/* table will be here */}
                                                    <div id="accordionExample4">
                                                        <div className="kt-widget4">
                                                            <div className="kt-widget4__item padding-tb5">
                                                                <table id="tblGreenFee" className="table table-bordered" style={{ width: '100%', backgroundColor: 'none' }}>
                                                                    <thead>
                                                                        <tr>
                                                                            <th style={{ width: '5%' }}>No</th>
                                                                            <th style={{ width: '15%' }}>Particular</th>
                                                                            <th style={{ width: '5%' }}>Holes</th>
                                                                            <th style={{ width: '10%' }}>Days</th>
                                                                            <th style={{ width: '10%' }}>Green Fee</th>
                                                                            <th style={{ width: '10%' }}>Cart</th>
                                                                            <th style={{ width: '10%' }}>Caddy</th>
                                                                            <th style={{ width: '10%' }}>Tax</th>
                                                                            <th style={{ width: '10%' }}>Total</th>
                                                                            <th style={{ width: '15%' }}>Remarks</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {greenFeeMaster.length > 0 && greenFeeMaster.map((detail, index) => (
                                                                            <tr key={index}>
                                                                                <td>{index + 1}</td>
                                                                                <td>{detail?.UserType}</td>
                                                                                <td>{detail?.Hole}</td>
                                                                                <td>{detail?.Type}</td>
                                                                                <td>
                                                                                    <input
                                                                                        type="number"
                                                                                        className="form-control input-sm"
                                                                                        value={detail?.GreenFee || 0}
                                                                                        disabled={!isRateEditable}
                                                                                        onChange={(e) => updateGreenFeeMasterRate(detail.UserType, detail.Hole, detail.Type, 'GreenFee', e.target.value)} 
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="number"
                                                                                        className="form-control input-sm"
                                                                                        value={detail?.Cart || 0}
                                                                                        disabled={!isRateEditable}
                                                                                        onChange={(e) => updateGreenFeeMasterRate(detail.UserType, detail.Hole, detail.Type, 'Cart', e.target.value)} 
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="number"
                                                                                        className="form-control input-sm"
                                                                                        value={detail?.Caddy || 0}
                                                                                        disabled={!isRateEditable}
                                                                                        onChange={(e) => updateGreenFeeMasterRate(detail.UserType, detail.Hole, detail.Type, 'Caddy', e.target.value)} 
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="number"
                                                                                        className="form-control input-sm"
                                                                                        value={Math.round(detail?.Tax) || 0}
                                                                                        disabled
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="number"
                                                                                        className="form-control input-sm"
                                                                                        value={Math.round(detail?.Total) || 0}
                                                                                        disabled
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <textarea
                                                                                        className="form-control input-sm"
                                                                                        style={{ width: '100%', height: '40px' }}
                                                                                        rows="3"
                                                                                        value={detail.Remark || ''}
                                                                                        onChange={(e) => updateGreenFeeMasterRate(detail.UserType, detail.Hole, detail.Type, 'Remark', e.target.value)}
                                                                                    ></textarea>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-12">
                                                                <div className="clearfix form-actions">
                                                                    <button type="button" id="btnSave" name="btnSave" className="btn btn-primary" onClick={handleSave}>
                                                                        <i className="fa fa-save"></i> Save
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </RightSideDetails>                        
                            </>}
                        </div>
                    </div>
                </div>
            </div>
            {showModal && (
                <AddGreenFeeCalendar
                    show={showModal}
                    onDismissModal={handleDismissModal}
                    refetchCalendars={refetchCalendars}
                    calendarData = {editingCalendar}
                    isEdit = {!!editingCalendar} 
                />
            )}
        </>
    );
};

export default GreenFeeCalendar;











